import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import Button from "../../buttons/Button"

import styles from "./ChargerList.module.scss"

const ChargerList = ({ charger, compact = false }) => {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()

  const gotToConfigure = charger => {
    navigate(`/${i18n.language}/configure/${charger.code}`)
  }

  return (
    <div className={compact ? `${styles.chargerContainer} ${styles.compact}` : styles.chargerContainer}>
      <div className={styles.chargerTextContainer}>
        <div>
          <div className={styles.chargerAction}>
            <Button
              primary={true}
              type="button"
              onClick={() => {
                gotToConfigure(charger)
              }}
            >
              {t(`chargers.${charger.code}.title`)}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChargerList
